// chatApi.js
// Conversation API integration

import axios from '../../../services/axios';

// Listaa keskustelut
async function listConversations({ pageParam = 1, limit = 20 } = {}) {
  const res = await axios.get('/conversations', {
    params: {
      sortBy: 'createdAt:desc',
      limit,
      page: pageParam,
    },
  });
  return res.data;
}

// Luo uusi keskustelu ja palauta event stream reader
async function createConversation(message) {
  try {
    const loggedUser = window.localStorage.getItem('loggedUser');
    if (!loggedUser) {
      throw new Error('Ei kirjautunut käyttäjä');
    }

    const { tokens } = JSON.parse(loggedUser);
    if (!tokens?.access?.token) {
      throw new Error('Ei voimassa olevaa tokenia');
    }

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${tokens.access.token}`,
      'Accept': 'text/event-stream',
    };

    const response = await fetch(`${axios.defaults.baseURL}/conversations`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ message }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    if (!response.body) {
      throw new Error('No response body for SSE stream!');
    }

    return response.body.getReader();
  } catch (error) {
    console.error('Error creating conversation:', error);
    throw error;
  }
}

// Streamaa viestit
async function streamMessages(conversationId, message) {
  try {
    const loggedUser = window.localStorage.getItem('loggedUser');
    if (!loggedUser) {
      throw new Error('Ei kirjautunut käyttäjä');
    }

    const { tokens } = JSON.parse(loggedUser);
    if (!tokens?.access?.token) {
      throw new Error('Ei voimassa olevaa tokenia');
    }

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${tokens.access.token}`,
      'Accept': 'text/event-stream',
    };

    const response = await fetch(`${axios.defaults.baseURL}/conversations/${conversationId}/messages`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ message }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    if (!response.body) {
      throw new Error('No response body for SSE stream!');
    }

    return response.body.getReader();
  } catch (error) {
    console.error('Error streaming messages:', error);
    throw error;
  }
}

// Apufunktio event streamin lukemiseen
async function readEventStream(reader, onEvent) {
  const decoder = new TextDecoder('utf-8');
  let buffer = '';
  let eventType = null;

  while (true) {
    let result;
    try {
      result = await reader.read();
    } catch (err) {
      throw new Error('Yhteys katkesi (reader.read error)');
    }
    if (!result) break;
    const { value, done } = result;
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    let lines = buffer.split('\n');
    buffer = lines.pop();

    for (let line of lines) {
      if (line.startsWith('event:')) {
        eventType = line.replace('event:', '').trim();
      }
      if (line.startsWith('data:')) {
        let data = line.replace('data:', '').trim();
        try { 
          data = JSON.parse(data); 
        } catch {}
        onEvent(eventType, data);
      }
    }
  }
}

// Hae yksittäinen keskustelu ja sen viestit
async function getConversation(conversationId) {
  const loggedUser = window.localStorage.getItem('loggedUser');
  if (!loggedUser) {
    throw new Error('Ei kirjautunut käyttäjä');
  }
  const { tokens } = JSON.parse(loggedUser);
  if (!tokens?.access?.token) {
    throw new Error('Ei voimassa olevaa tokenia');
  }
  const headers = {
    'Authorization': `Bearer ${tokens.access.token}`,
  };
  const res = await axios.get(`/conversations/${conversationId}`, { headers });
  return res.data;
}

const chatApi = {
  listConversations,
  createConversation,
  streamMessages,
  readEventStream,
  getConversation,
};

export default chatApi; 